// packages/world-model/src/traits/wearable/index.ts

export * from './wearableTrait';
export * from './wearableBehavior';